import { API_BASE_URL } from "./apiBaseUrl";
import {fetchClientInstance} from "@/src/shared/api/fetchClientInstance";

// Because cache() function from react is not stable yet and in server components we need next cache
// better off use native fetch api which has 'force-cache' by default, provided by next. For other requests we use axios

export const GET = async (url: string, options: RequestInit = {}) => {
    const response = await fetchClientInstance(`${API_BASE_URL}${url}`, {
        method: "GET",
        ...options,
    });

    if (!response.ok) throw new Error(`Error in request ${url} with status ${response.status} ${response.statusText}`)

    return response;
};
